import React, { forwardRef } from 'react';
import { useTextInput } from '../TextInput';

export interface IInputProps extends React.ComponentProps<'input'> {
  children?: React.ReactNode;
  /** the placeholder, mandatory to handle info/success/errors texts with css pseudo element `placeholder-shown` */
  placeholder: string;
  dataTestId?: string;
  UNSAFE_className?: string;
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(
  ({ children, dataTestId, UNSAFE_className = '', ...props }, ref) => {
    const { id, isValid, isInvalid } = useTextInput();

    return (
      <div className="tw-lf-input-icons-container tw-w-full">
        <input
          className={`${UNSAFE_className} tw-peer tw-lf-input disabled:tw-lf-input-disabled invalid:[&:not(:placeholder-shown)]:tw-lf-input-invalid  [&:has(+.left-icon)]:tw-pl-12 [&:has(~.right-icon)]:tw-pr-12 ${
            isValid ? 'tw-lf-input-valid' : ''
          } ${isInvalid ? 'tw-lf-input-invalid' : ''}`}
          id={id}
          ref={ref}
          data-testid={dataTestId}
          {...props}
        />
        {children}
      </div>
    );
  },
);
